// Hero — the gradient banner at the top of every guide page.

import { Link } from 'react-router-dom';
import type { Crumb } from '../types';

interface HeroProps {
  /**
   * Breadcrumb segments. Strings are rendered as plain text;
   * { to, label } objects become <Link>s.
   *
   * Example: [{ to: '/', label: 'Knowledge Base' }, "Teachers' Guide"]
   */
  crumbs?: Crumb[];
  /** The leading word(s) of the title in default colour. */
  titleMain: string;
  /** The trailing word(s) of the title rendered in brand teal. */
  titleAccent?: string;
  /** Optional descriptive paragraph below the title. */
  subtitle?: string;
}

export default function Hero({
  crumbs = [],
  titleMain,
  titleAccent,
  subtitle,
}: HeroProps) {
  return (
    <section className="hero">
      <div className="hero__content">

        {crumbs.length > 0 && (
          <div className="hero__breadcrumb">
            {crumbs.map((crumb, i) => {
              const isLast = i === crumbs.length - 1;
              // Type-narrow: strings are plain text, objects are links.
              const node =
                typeof crumb === 'string'
                  ? <span>{crumb}</span>
                  : <Link to={crumb.to}>{crumb.label}</Link>;

              return (
                <span key={i}>
                  {node}
                  {!isLast && <span className="sep">/</span>}
                </span>
              );
            })}
          </div>
        )}

        <h1 className="hero__title">
          {titleMain}
          {titleAccent && <> <span className="accent">{titleAccent}</span></>}
        </h1>

        {subtitle && <p className="hero__subtitle">{subtitle}</p>}
      </div>
    </section>
  );
}
